import { render, staticRenderFns } from "./Indexed.vue?vue&type=template&id=c0d28b98&scoped=true&"
import script from "./Indexed.vue?vue&type=script&lang=ts&"
export * from "./Indexed.vue?vue&type=script&lang=ts&"
import style0 from "./Indexed.vue?vue&type=style&index=0&id=c0d28b98&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0d28b98",
  null
  
)

export default component.exports